export default __webpack_public_path__ + "static/media/userSelected.7721b168.svg";